import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import ErrorView from 'app/components/ErrorView'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  errorBox: {
    padding: '0 20%',
  },
}))

const getTitleByError = ({ error = {}, formatMessage }) => {
  if (error.message === 'Network Error') {
    return formatMessage(
      { id: 'error.network.unavailable.title' },
      { newline: <br /> },
    )
  }

  return formatMessage({ id: 'error.general.title' }, { newline: <br /> })
}

const getSubtitleByError = ({ error = {}, formatMessage }) => {
  if (error.message === 'Network Error') {
    return formatMessage(
      { id: 'error.network.unavailable.body' },
      { newline: <br /> },
    )
  }

  return formatMessage({ id: 'error.general.subTitle' }, { newline: <br /> })
}

const ErrorFetchingLoading = (props) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const { isShow, onLoadSuccess, title, subtitle, error } = props

  if (!isShow) {
    return null
  }

  return (
    <div className={clsx('text-center', classes.errorBox)}>
      <ErrorView
        action={onLoadSuccess}
        title={title || getTitleByError({ error, formatMessage })}
        subtitle={subtitle || getSubtitleByError({ error, formatMessage })}
      />
    </div>
  )
}

ErrorFetchingLoading.propTypes = {
  isShow: PropTypes.bool,
  onLoadSuccess: PropTypes.func,
  error: PropTypes.object,
}

export default ErrorFetchingLoading
